export const Christmas = {
    snowFlakeNumber: 200,
    letItSnow: () => {
        let body = document.querySelector('body');
        body.classList.toggle('christmas-time-is-here');
        let snowDrift = document.querySelector("[data-christmas-snow]");
        if (snowDrift) {
            snowDrift.classList.remove('hidden');
            for (let i = 0; i < Christmas.snowFlakeNumber; i++ ) {
                console.log("snow");
                $(snowDrift).append($(`
                    <div class="snow"></div>
                `));
            }
        }
    }
}


//Christmas additions for reversion

//CHRISTMAS revert
// remove import of Christmas.js in theme.js
// remove get_template_part and conditional logic for team-christmas-card.php in loop-archive-grid.php
// remove import of _christmas.scss
